<template>
  <div class="w-100">
    <div class="col-md-12 mt-2">
      <div class="d-flex justify-content-between">
        <button class="fw-bold p-2 mb-2 btn bg-white shadow-sm bg-body rounded" @click="addDefaultOrderFee">
          Order Fee Setting
          <img width="18" src="@/assets/sidebar/sidebar-icon-manage.svg" alt=""/>
        </button>
      </div>

      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <p class="fw-bold modal-title fsize-16" id="exampleModalLabel">Edit Commission </p>
            </div>
            <div class="modal-body">
              <div class="row mb-3">
                <label class="d-flex align-items-center col-sm-5 col-form-label fw-bold text-start">
                  Seller Commission
                  <PopOver :text="infoCommission">
                    <font-awesome-icon class="ms-2" icon="fa-solid fa-circle-info" />
                  </PopOver>
                </label>
                <div class="col-md-6 ms-3">
                  <div class="row">
                    <input type="number" class="form-control rounded-start" aria-label="Search By"
                      aria-describedby="basic-addon2" style="border-right: 0px !important;width: 150px;"
                      @keydown="isNumber()"
                      v-model="passedData.comission" />
                    <p class="border border-start-0 pt-1 rounded-end mb-0 rounded-end" style="width: 30px;">%</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="m-3 d-flex justify-content-start">
              <button type="button" class="btn btn-secondary bg-white border border-danger text-danger rounded me-3 text-uppercase"
                data-bs-dismiss="modal">Cancel</button>
              <button v-if="passedData.comission !== ''" type="button" class="btn btn-danger text-white shadow-sm rounded text-uppercase" data-bs-dismiss="modal" @click="submit">Save
                Commission</button>
              <button v-else type="button" class="btn btn-secondary text-uppercase" disabled>Save Commission</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:store_name="{data}">
        <div>
          <router-link
            :to="`/users/sellers/${data.id}`"
            class="text-decoration-none fw-bold"
          >
            {{ data.store_name }}
          </router-link>
        </div>
      </template>

      <template v-slot:seller_comission_display="{data}">
        <span style="text-align: right;color:#5E50A1" class="fw-bold">
          {{ data.seller_comission_display }}
        </span>
      </template>
      <template v-slot:actions="{ value }">
        <div>
          <button
            class="fw-bold p-2 btn border-0"
            :class="value.edit == 'disable' ? 'disabled' : ''"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            @click="sendInfo({id: value.id, comission: value.comission})">
              <div class="d-flex align-items-center" :style="{gap : '8px'}">
                <img src="@/assets/ic_edit.svg"  alt="edit"/>
                <span :style="{color: '#5e50a1'}">
                  Edit Commission
                </span>
              </div>
          </button>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
import PopOver from "@/components/PopOver.vue";

export default {
  components: {
      TableBasic,
      PopOver
  },
  data() {
    return {
      payload: {
        filter: true,
        filterLabel: "Filter by Registered date",
        filterLabelDefault : true,
        datepickerOption: {
          autoApply: true,
          timePicker: false,
        },
        header: [
          {
            key: "id",
            label: "SELLER ID",
            link: "/users/sellers"
          },
          {
            key: "store_name",
            label: "SELLER NAME",
          },
          {
            key: "seller_comission_display",
            label: "COMMISSION (IN %)",
            style: "text-align: right;"
          },
          {
            key: "comission_updated_date",
            label: "LATEST UPDATE",
            class: "text-center",
            sort_key: "comission_updated_date",
            sort: true
          },
          {
            key: "created_date",
            label: "REGISTERED DATE",
            class: "text-center",
            sort_key: "created_date",
            sort: true
          },
          {
            key: "actions",
            label: "ACTIONS",
            class: "text-justify",
          }
        ],
        value: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 50, 100],
        search: true,
        startDate: "",
        endDate: "",
        searchPlaceholder: "ID, Seller Name or Commission",
      },
      filterValue: {},
      passedData: {id: null, comission: null},
      infoCommission: "Set this Commission if you want the Seller to have different commission scheme than the default setting."
    };
  },
  watch:{
    "passedData.comission": function(val){
      if(val < 0) this.passedData.comission = 0
      if(val >= 100) this.passedData.comission = 100
    }
  },
  methods: {
    async addDefaultOrderFee() {
      this.$router.push("/finance/sellers-commission/orders-fee-setting");
    },
    changeParameter(value) {
      this.payload.perPage = value.per_page
      this.payload.currentPage = value.current_page
      this.searchInput = value.search
      this.payload.sortType = value.sort_type
      this.payload.sortBy = value.sort_by
      this.filterValue = value.filter
      this.getData()
    },
    async getData() {
      try {
        let payload = {
          page: this.payload.currentPage,
          size: this.payload.perPage
        }

        if (this.searchInput != "") {
          payload.keyword = this.searchInput
        }

        if (this.sortBy != "") {
          payload.sort_by = this.payload.sortBy
          payload.sort_type = this.payload.sortType
        }

        if (this.filterValue) {
          payload.date_start = this.filterValue.from
          payload.date_end = this.filterValue.to
        }

        const response = await this.$store.dispatch("order_fee/getAll", payload)
        if (response.data.data.items == null) {
          this.payload.value = response.data.data.items
        } else {
          let groupdata = this.$store.getters['order_fee/orderFeeItems']
          this.payload.value = groupdata
        }
        this.payload.totalRows = response.data.data.count
      } catch (error) {
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        })
      }
    },
    isNumber: (evt) => {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sendInfo(item) {
      this.passedData = item
    },
    async submit() {
      try {
        const payload = {
          "seller_id": this.passedData.id,
          "seller_comission": parseInt(this.passedData.comission)
        }
        await this.$store.dispatch("order_fee/submitComission", payload)
        this.getData()

      } catch (error) {
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        })
      }
    }
  },
  mounted() {
    this.getData()
  },
};
</script>

<style></style>
